<template>
    <v-dialog v-model="value.showDialog" hide-overlay persistent max-width="800px">
        <bot-spinner v-model="spinner">
            <v-card class="project-item" :loading="spinner.visible">
                <v-card-title>
                    <span>Cập nhật từ khóa</span>
                    <v-spacer></v-spacer>
                    <v-btn color="success darken-1" text @click="submit" :disabled="!isValid">
                        <v-icon left> mdi-check </v-icon>
                        Xác nhận
                    </v-btn>
                    <v-btn color="pink" text @click="handleCloseDialog">
                        <v-icon left> mdi-close </v-icon>
                        Hủy
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-form v-model="isValid" ref="form" @submit.prevent="submit">
                        <v-textarea outlined rows="12" label="mỗi dòng 1 từ khóa"
                            v-model="value.KeywordText"></v-textarea>
                    </v-form>
                </v-card-text>
            </v-card>
        </bot-spinner>
    </v-dialog>
</template>

<script>
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            link: {
                ranking: {
                    updateList: "views/link/ranking/updateList",
                },
            },
        },
    },
    sms: {
        invalid: {
            project: "Bạn chưa chọn dự án!",
            keywords: "Bạn chưa nhập từ khóa"
        },
        success: "Cập nhật từ khóa thành công!"
    },
};
const df = cafe.default;

export default {
    name: "link-ranking-item",

    props: ["value"],

    components: {
        "bot-spinner": BotSpinner,
    },

    // this is state
    data() {
        return {
            isValid: false,
            vld: this.$options.filters.validate,
            hlog: this.$options.filters.hlog,
            isValid: false,
            spinner: {
                visible: false,
                color: "red",
            },
        };
    },

    computed: {
        ua() {
            return this.$store.state.useragent;
        },
    },

    methods: {
        async submit() {
            var main = this;
            const dp = main.$store.dispatch;
            let { prj, KeywordText } = main.value;
            if (!prj || !prj.ProjectID) return dp(df.sp.snb, { text: cafe.sms.invalid.project, color: "warning" });
            if (!KeywordText || !KeywordText.trim()) return dp(df.sp.snb, { text: cafe.sms.invalid.keywords, color: "warning" });
            KeywordText = KeywordText.trim();
            let temp = {
                keywords: {}
            };
            let tKeywordList = [];
            let arr = KeywordText.split("\n");
            for (let KeywordName of arr) {
                KeywordName = KeywordName.replace(/\s{2,}/g, " ").trim();
                let kw = temp.keywords[KeywordName];
                if (kw) continue;
                kw = { KeywordID: null, KeywordName };
                tKeywordList.push(kw);
            };
            const { ProjectID, ProjectName } = prj;
            console.log("tKeywordList", tKeywordList);
            main.hlog.start("keywords.update", "start", ProjectID);
            let text;
            let payload = { ProjectID, tKeywordList };
            let storePath = df.sp.link.ranking.updateList;
            main.spinner.visible = true;
            let res_update = await dp(storePath, payload);
            text = res_update.error;
            if (text) return dp(df.sp.snb, { text, color: "error" });
            text = cafe.sms.success;
            main.value.showDialog = false;
            dp(df.sp.snb, { text, color: "success" });
        },
        handleCloseDialog() {
            this.value.showDialog = false;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// link.ranking.item.vue